const SUPPORT_BOGE_LINK = 'https://support.boge.com';

export const isSupportBogeLink = (link: string): boolean => link.startsWith(SUPPORT_BOGE_LINK);
